import React, {useRef} from "react";
import { View, Text, TouchableOpacity, Image } from "react-native";
import { useProfile } from "../../hooks/Profile/useProfile";
import ScreenContainer from "../../components/Containers/ScreenContainer";
import TimeTrackerMini from "../../components/MiniPlayer/TimeTrackerMini";
import { useNavigation } from "@react-navigation/native";
import { StackNavigationProp } from "@react-navigation/stack";
import { RootStackParamList } from "../../navigation/types";
import RequestEntrySheet, {RequestEntrySheetRef} from "../../components/Request/RequestEntrySheet";


export default function ProfileScreen() {
  const { user, logout } = useProfile();
  const requestSheetRef = useRef<RequestEntrySheetRef>(null);

   const navigation = useNavigation<StackNavigationProp<RootStackParamList>>();
  // Obtener la inicial del usuario
  const getInitial = (name: string) => name ? name.charAt(0).toUpperCase() : "?";

  return (
    <ScreenContainer>
      <View className="items-center mt-20">
        {user.photo || user.avatar ? (
          <Image
            source={{ uri: user.photo || user.avatar }}
            className="w-24 h-24 rounded-full mb-4"
          />
        ) : (
          <View className="w-24 h-24 rounded-full bg-gray-600 mb-4 flex items-center justify-center">
            <Text className="text-white text-4xl font-bold">
              {getInitial(user.name)}
            </Text>
          </View>
        )}

        <Text className="text-2xl font-semibold">{user.name}</Text>
        <Text className="text-gray-400 text-lg">{user.email}</Text>
      </View>

      <View className="mt-6 p-4 bg-gray-800 rounded-lg">
        <Text className="text-white text-lg font-semibold mb-2">Configuration</Text>
        <Text className="text-gray-400">• Notifications: Active</Text>
        <Text className="text-gray-400">• Language: English</Text>
      </View>

      <TouchableOpacity className="bg-red-600 p-4 rounded-lg mt-6" onPress={logout}>
        <Text className="text-white text-center text-lg font-semibold">Log Out</Text>
      </TouchableOpacity>
{/* 
      <TouchableOpacity onPress={() => requestSheetRef.current?.show()}>
        <Text>Open Time Request Sheet</Text>
      </TouchableOpacity>


      <RequestEntrySheet
        ref={requestSheetRef}
        onSubmit={(data) => {
          console.log("Time correction request sent", data);
          // Puedes hacer un POST a tu backend aquí
        }}
      />

      <TouchableOpacity onPress={() => navigation.navigate("RequestEntryApproval")}>
        <Text>Open Time Request Sheet</Text>
      </TouchableOpacity> */}


    </ScreenContainer>
  );
}